import templateStr from 'text!./templates/binary-choice-group.html';

export default [function () {
    return {
        restrict: 'AE',
        template: templateStr,
        scope: {
            label: '@',
            titleLeft: '@',
            titleRight: '@',
            valueLeft: '=',
            valueRight: '=',
            model: '='
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/inputs/BinaryChoiceGroup.js
// module id = 773
// module chunks = 0